import React from "react";
import { Avatar } from "@material-ui/core";
import {
  ThumbDownAltOutlined,
  Reply,
  ThumbUpOutlined,
} from "@material-ui/icons";
import "../styles/CommentSection.css";

const CommentSection = () => {
  return (
    <div className="commentsection">
      <Avatar />
      <div className="commentsection__body">
        <div className="body__username">
          <h3>
            Username <span> 1 day ago</span>{" "}
          </h3>
          <p>lkasjdofgiagalskhgasghalskg</p>
        </div>

        <div className="commentsection__likeshare">
          <ThumbUpOutlined />
          <p>70</p>
          <ThumbDownAltOutlined />
          <p>12</p>
          <Reply />
          <p>Reply</p>
        </div>
      </div>
    </div>
  );
};

export default CommentSection;
